<template>
    <el-dialog
        :title="'装车顺序'"
        :width="'1300px'"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceDispatchSequenceDialog'"
    >
        <el-table :data="tableData" border :height="400" v-loading="loading">
            <el-table-column
                label="客户订单号"
                prop="customerOrderNo"
                fixed
                width="160"
            ></el-table-column>
            <el-table-column
                label="收货地址"
                prop="address"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="客户"
                prop="upperReceiverName"
                width="200"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="装车顺序" prop="wlLoadSequence" width="140">
                <template slot-scope="scope">
                    <el-input
                        clearable
                        placeholder="请输入装车顺序"
                        v-model.trim="scope.row.wlLoadSequence"
                        @input="handleInput(scope.row, 'wlLoadSequence')"
                        @change="(val) => elementChange(val, scope.row)"
                    />
                </template>
            </el-table-column>
        </el-table>
        <template #footer>
            <div>
                <el-button @click="beforeClose">取消</el-button>
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    @click="handleSubmit"
                    >确定</el-button
                >
            </div>
        </template>
    </el-dialog>
</template>
<script>
import { querySequenceList, updateWlLoadSequence } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { formatSequenceList, validateParams, dealWithParams } from './util.js';
export default {
    name: 'performanceDispatchSequence',
    props: {
        componentsData: {
            type: Object,
            default () { return {}; }
        }
    },
    data () {
        return {
            visible: false, // 是否显示弹窗
            loading: false,
            btnLoading: false,
            query: { pageNo: 1, pageSize: 1000 },
            tableData: [] // 列表数据
        };
    },
    methods: {
        // 获取装车顺序列表数据
        getList () {
            this.loading = true;
            querySequenceList({ dispatchNo: this.componentsData.dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = formatSequenceList(res.data || []);
                }
            }).finally(() => { this.loading = false; });
        },

        /**
         * @description 装车顺序字段，只能输入整数
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        handleInput (row, prop) {
            row[prop] = row[prop].replace(/[^\d|]+$/g, '').replace(/0/, '');
        },

        /**
         * @description 校验装车顺序是否已存在相同值
         * @param {String} val 装车顺序字段值
         */
        elementChange (val, row) {
            /**
             * @description 服务平台: 漯河城配经营中心 && 分公司(客户): 漯河市卫龙商贸有限公司 不做限制
             * siteCode: 75889459187
             * siteName: 漯河城配经营中心
             * customerCode: A0025764
             * customerName: 漯河市卫龙商贸有限公司
             */
            if (row.siteCode === '75889459187' && row.customerCode === 'A0025764') {
                return val;
            }
            // 先找到相同客户的数据，并赋值
            const findCommonCustomer = this.tableData.filter(v => v.upperReceiverName === row.upperReceiverName);
            findCommonCustomer.forEach(v => (v.wlLoadSequence = val));

            // 找到不同客户的数据
            const findDifferenceCustomer = this.tableData.filter(v => v.upperReceiverName !== row.upperReceiverName);
            const isExistVal = findDifferenceCustomer.some(v => v.wlLoadSequence === val);
            if (isExistVal) {
                this.$message.warning('此装车顺序已被别的客户使用，请重新输入');
                findCommonCustomer.forEach(v => (v.wlLoadSequence = ''));
            }
        },

        // 确定
        handleSubmit () {
            const isTrue = validateParams(this.tableData);
            if (!isTrue) return;
            this.btnLoading = true;
            const params = dealWithParams(this.componentsData, this.tableData);
            updateWlLoadSequence(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('保存成功');
                    this.beforeClose();
                }
            }).finally(() => { this.btnLoading = false; });
        },

        // 关闭
        beforeClose () {
            this.$emit('components-close');
        }
    },
    mounted () {
        this.visible = true;
        this.getList();
    }
};
</script>
